export const sendStatus = {
  Sending: "Sending",
  Created: "Created",
  SendFail: "SendFail",
  Unsend: "Unsend",
  Delete: "Delete",
  Copy: "Copy",
  New: "New",
  Success: "Success",
  Update: "Update",
  Reply: "Reply",
  Forward: "Forward",
  Deleted: "deleted",
  Updated: "updated",
};
export const messageTypes = {
  Text: "text",
  Link: "link",
  Image: "image",
  Audio: "audio",
  Video: "video",
  Sound: "chat_sound",
  Sticker: "sticker",
  CenterFlie: "center_file",
  Reply: "reply",
  CheckIn: "check_in",
  JoinGroup: "join_group",
  LeaveGroup: "leave_group",
  KickGroup: "kick_group",
  Invited: "invited_group",
  MeetingRecord: "meeting_record",
  MissedCall: "missed call",
  CallEnded: "call ended",
  CallFail: "call fail",
  StartingChat: "starting_chat"
};
export const Service = {
  ChatSaveMessage: "/api/save/message",
  ChatSaveMessageImage: "/api/save/messagesImage",
  ChatSaveReadMessage: "/api/save/readMessage",
  ChatSaveListMessages: "/api/save/listMessages",
  ChatSaveTransactionMessage: "/api/save/transactionMessage",
  ChatFindMessage: "/api/find/messages",
  ChatFindMessageNew: "/api/find/messagesNew",
  ChatFindMessageUnread: "/api/find/messagesUnread",
  ChatFindMessageUpdate: "/api/find/messagesUpdate",
  ChatGetStickerPackages: "/api/find/stickerPackages",
  ChatGetMySticker: "/api/find/mySticker",
  ChatUnsendMessage: "/api/update/unsendMessage",
  FileSreviceUploadFile: "/uploadFile",
  FileSreviceDeleteFile: "/deleteFile",
  FileSreviceDownloadFile: "/downloadFile",
  FileSreviceMoveFileToTrash: "/moveFileToTrash",
  CenterOpengraph: "/api/v1/crawler/og",
  CenterGetGroup: "/api/v2/groups/",
  CenterGetFriends: "/api/v1/users/friends",
  CenterCheckTopic: "/api/v2/groups/topic",
};
export const messageTemplates = {
  [messageTypes.Link]: "{{.Firstname}} send a link.",
  [messageTypes.Image]: "{{.Firstname}} send a photo.",
  [messageTypes.Sound]: "{{.Firstname}} send a voice message.",
  [messageTypes.Video]: "{{.Firstname}} send a video.",
  [messageTypes.Sticker]: "{{.Firstname}} send a sticker.",
  [messageTypes.CenterFlie]: "{{.Firstname}} shared a file",
  [messageTypes.Reply]: "{{.Firstname}} reply a message",
  [messageTypes.CheckIn]: "{{.Firstname}} checked in",
  [messageTypes.JoinGroup]: "{{.Firstname}} joined group {{.GroupName}}",
  [messageTypes.LeaveGroup]: "{{.Firstname}} leave group {{.GroupName}}",
  [messageTypes.Invited]: "",
  [messageTypes.MeetingRecord]: "send a meeting recorded.",
};
export const limitLoadMessage = 15;
export const limitSliceMessage = 15;
export const limitForward = 20;
export const limitDateStorage = 2;
export const expDomain = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
export const expURL = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,256}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/g;
export const newExpURL = /(https?|http?):\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
export const expEmail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gim;
export const expImgges = /(gif|jpe?g|tiff|png|360-DEGREE|jfif|360-degree|bmp)$/i;
export const expMedias = /(m4v|avi|mpg|mp4|webm|mov|mp3|m4a)$/i;
export const expVideo = /(m4v|avi|mpg|mp4|webm|mov)$/i;
export const expAudio = /(mp3|wav|wma|aac|m4a)$/i;
export const expMention = /^@[A-Za-z0-9-]+/g;